var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnNavLayers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 36,
    viewBox: "0 0 52 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -10,
    y: -10,
    width: 72,
    height: 56
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(5px)",
      clipPath: "url(#bgblur_0_21207_90760_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H44C48.4183 0 52 3.58172 52 8V36H0V8Z",
    fill: "#4D5165",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 24L33.36 18.27L35 17L26 10L17 17L18.63 18.27L26 24ZM25.99 26.54L18.62 20.81L17 22.07L26 29.07L35 22.07L33.37 20.8L25.99 26.54ZM31.7398 17.0012L25.9998 12.5312L20.2598 17.0012L25.9998 21.4712L31.7398 17.0012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.7393,
    y: 4,
    width: 4.52174,
    height: 2,
    rx: 1,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_21207_90760_clip_path",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H44C48.4183 0 52 3.58172 52 8V36H0V8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnNavLayers);
export default __webpack_public_path__ + "static/media/btn-nav-layers.a29778ab0c4715ff7d817a09a9e0b2e5.svg";
export { ForwardRef as ReactComponent };